/* eslint-disable */
import { fetch } from "./fetch"
import api from './url'

// 获取版本数据
// export function version() {
//   return fetch({
//     url: api.test,
//     method: 'get',
//     params:{
//       page: 1,
//       per_page: 2
//     }
//   })
// }

export default {
	// 账号模块
	accountList: function(params) {
		return fetch({
		    url: api.accountList,
		    method: 'get',
		    params: params
		})
	},
	accountInfo: function(id) {
		return fetch({
		    url: api.accountInfo + id,
		    method: 'get',
		    params: {}
		})
	},
    accountPlanText: function(id) {
        return fetch({
            url: api.accountPlanText + id,
            method: 'get',
            params: {}
        })
    },
	accountThirdList: function(params) {
		return fetch({
		    url: api.accountThirdList,
		    method: 'get',
		    params: params
		})
	},
	accountDelete: function(id) {
		return fetch({
		    url: api.accountDelete + id,
		    method: 'delete'
		})
	},
	accountMigrate: function(data) {
		return fetch({
		    url: api.accountMigrate,
		    method: 'post',
		    data: data
		})
	},
    accountUpType: function(data) {
        return fetch({
            url: api.accountUpType,
            method: 'post',
            data: data
        })
    },

	// 用户模块
	userList: function(params) {
		return fetch({
		    url: api.userList,
		    method: 'get',
		    params: params
		})
	},
	userUpLevel: function(data) {
		return fetch({
		    url: api.userUpLevel,
		    method: 'put',
		    data: data
		})
	},
	userCreate: function(data) {
		return fetch({
		    url: api.userCreate,
		    method: 'post',
		    data: data
		})
	},
	userInfo: function(id) {
		return fetch({
		    url: api.userInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	userOrderList: function(params) {
		return fetch({
		    url: api.userOrderList,
		    method: 'get',
		    params: params
		})
	},
	userDeviceList: function(params) {
		return fetch({
		    url: api.userDeviceList,
		    method: 'get',
		    params: params,
		})
	},
	userDeviceCloudList: function(params) {
		return fetch({
		    url: api.userDeviceCloudList,
		    method: 'get',
		    params: params
		})
	},
	userDelete: function(id) {
		return fetch({
		    url: api.userDelete + id,
		    method: 'delete'
		})
	},
	userUploadExcel: function() {
		return api.userUploadExcel
	},

	// 产品模块管理
	productList: function(params) {
		return fetch({
		    url: api.productList,
		    method: 'get',
		    params: params
		})
	},
	productCreate: function(data) {
		return fetch({
		    url: api.productCreate,
		    method: 'post',
		    data: data
		})
	},
	productInfo: function(id) {
		return fetch({
		    url: api.productInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	productPackgeList: function(id) {
		return fetch({
		    url: api.productPackgeList + id,
		    method: 'get',
		    params: {}
		})
	},
	productFuncList: function(id) {
		return fetch({
		    url: api.productFuncList + id,
		    method: 'get',
		    params: {}
		})
	},
	productUpdate: function(data) {
		return fetch({
		    url: api.productUpdate,
		    method: 'put',
		    data: data
		})
	},
	productUpStatus: function(data) {
		return fetch({
		    url: api.productUpStatus,
		    method: 'put',
		    data: data
		})
	},
	productUpSort: function(data) {
		return fetch({
		    url: api.productUpSort,
		    method: 'put',
		    data: data
		})
	},
	productDelete: function(id) {
		return fetch({
		    url: api.productDelete + id,
		    method: 'delete'
		})
	},
	productSecret: function(id) {
		return fetch({
		    url: api.productSecret + id,
		    method: 'get',
		    params: {} 
		})
	},


	// 产品功能管理
	proFuncList: function(params) {
		return fetch({
		    url: api.proFuncList,
		    method: 'get',
		    params: params
		})
	},
	proFuncCreate: function(data) {
		return fetch({
		    url: api.proFuncCreate,
		    method: 'post',
		    data: data
		})
	},
	proFuncInfo: function(id) {
		return fetch({
		    url: api.proFuncInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	proFuncUpdate: function(data) {
		return fetch({
		    url: api.proFuncUpdate,
		    method: 'put',
		    data: data
		})
	},
	proFuncUpStatus: function(data) {
		return fetch({
		    url: api.proFuncUpStatus,
		    method: 'put',
		    data: data
		})
	},
	proFuncDelete: function(id) {
		return fetch({
		    url: api.proFuncDelete + id,
		    method: 'delete'
		})
	},

	// 套餐管理
	packList: function(params) {
		return fetch({
		    url: api.packList,
		    method: 'get',
		    params: params
		})
	},
	packCreate: function(data) {
		return fetch({
		    url: api.packCreate,
		    method: 'post',
		    data: data
		})
	},
	packInfo: function(id) {
		return fetch({
		    url: api.packInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	packUpdate: function(data) {
		return fetch({
		    url: api.packUpdate,
		    method: 'put',
		    data: data
		})
	},
	packUpStatus: function(data) {
		return fetch({
		    url: api.packUpStatus,
		    method: 'put',
		    data: data
		})
	},
	packDelete: function(id) {
		return fetch({
		    url: api.packDelete + id,
		    method: 'delete'
		})
	},

	// 出厂设备管理模块
	factoryList: function(params) {
		return fetch({
		    url: api.factoryList,
		    method: 'get',
		    params: params
		})
	},
	factoryBatchCreate: function(data) {
		return fetch({
		    url: api.factoryBatchCreate,
		    method: 'post',
		    data: data
		})
	},
	factoryBatchUuid: function(data) {
		return fetch({
		    url: api.factoryBatchUuid,
		    method: 'post',
		    data: data
		})
	},
    factoryImportMac: function() {
        return api.factoryImportMac;
    },
	factoryRecordList: function(params) {
		return fetch({
		    url: api.factoryRecordList,
		    method: 'get',
		    params: params
		})
	},
	factoryRecordAllow: function(data) {
		return fetch({
		    url: api.factoryRecordAllow,
		    method: 'post',
		    data: data
		})
	},
	factoryDownExcel: function(data) {
		return fetch({
		    url: api.factoryDownExcel,
		    method: 'post',
		    data: data,
	        responseType: 'blob',
		})
	},
	factoryDelete: function(id) {
		return fetch({
		    url: api.factoryDelete + id,
		    method: 'delete'
		})
	},
	factorySecret: function(id) {
		return fetch({
		    url: api.factorySecret + id,
		    method: 'get',
		    params: {}
		})
	},
	
	// 已上线设备管理模块
	deviceList: function(params) {
		return fetch({
		    url: api.deviceList,
		    method: 'get',
		    params: params
		})
	},
	deviceInfo: function(id) {
		return fetch({
		    url: api.deviceInfo,
		    method: 'get',
		    params: {"uuid":id}
		})
	},
	deviceUserList: function(params) {
		return fetch({
		    url: api.deviceUserList,
		    method: 'get',
		    params: params
		})
	},
	
	// 大拿设备管理模块
	danaDeviceList: function(params) {
		return fetch({
		    url: api.danaDeviceList,
		    method: 'get',
		    params: params
		})
	},
	danaDeviceUpRole: function(data) {
		return fetch({
		    url: api.danaDeviceUpRole,
		    method: 'put',
		    data: data
		})
	},
	danaDeviceUpRoles: function(data) {
		return fetch({
		    url: api.danaDeviceUpRoles,
		    method: 'put',
		    data: data
		})
	},
	danaDeviceWhereUpRoles: function(data) {
		return fetch({
		    url: api.danaDeviceWhereUpRoles,
		    method: 'put',
		    data: data
		})
	},
	danaDeviceUploadExcel: function() {
		return api.danaDeviceUploadExcel
	},
	danaFacilityList: function(params) {
		return fetch({
		    url: api.danaFacilityList,
		    method: 'get',
		    params: params
		})
	},

    // 工厂SN标识库管理
    snFactoryList: function(params) {
        return fetch({
            url: api.snFactoryList,
            method: 'get',
            params: params
        })
    },
    snFactoryCreate: function(data) {
        return fetch({
            url: api.snFactoryCreate,
            method: 'post',
            data: data
        })
    },
    snFactoryUpdate: function(data) {
        return fetch({
            url: api.snFactoryUpdate,
            method: 'put',
            data: data
        })
    },
    snFactoryDelete: function(id) {
        return fetch({
            url: api.snFactoryDelete + id,
            method: 'delete'
        })
    },

    // 产品SN标识库管理
    snProductList: function(params) {
        return fetch({
            url: api.snProductList,
            method: 'get',
            params: params
        })
    },
    snProductCreate: function(data) {
        return fetch({
            url: api.snProductCreate,
            method: 'post',
            data: data
        })
    },
    snProductInfo: function(id) {
        return fetch({
            url: api.snProductInfo + id,
            method: 'get',
            params: {}
        })
    },
    snProductUpdate: function(data) {
        return fetch({
            url: api.snProductUpdate,
            method: 'put',
            data: data
        })
    },
    snProductDelete: function(id) {
        return fetch({
            url: api.snProductDelete + id,
            method: 'delete'
        })
    },

	// 版本管理模块
	versionList: function(params) {
		return fetch({
		    url: api.versionList,
		    method: 'get',
		    params: params
		})
	},
	versionCreate: function(data) {
		return fetch({
		    url: api.versionCreate,
		    method: 'post',
		    data: data
		})
	},
	versionInfo: function(params) {
		return fetch({
		    url: api.versionInfo,
		    method: 'get',
		    params: params
		})
	},
	versionUpdate: function(data) {
		return fetch({
		    url: api.versionUpdate,
		    method: 'put',
		    data: data
		})
	},
	versionUpStatus: function(data) {
		return fetch({
		    url: api.versionUpStatus,
		    method: 'put',
		    data: data
		})
	},
	versionDelete: function(id) {
		return fetch({
		    url: api.versionDelete + id,
		    method: 'delete'
		})
	},

	// APP管理模块
	appList: function(params) {
		return fetch({
		    url: api.appList,
		    method: 'get',
		    params: params
		})
	},
	appCreate: function(data) {
		return fetch({
		    url: api.appCreate,
		    method: 'post',
		    data: data
		})
	},
	appInfo: function(id) {
		return fetch({
		    url: api.appInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	appSecret: function(id) {
		return fetch({
		    url: api.appSecret + id,
		    method: 'get',
		    params: {}
		})
	},
	appUpdate: function(data) {
		return fetch({
		    url: api.appUpdate,
		    method: 'put',
		    data: data
		})
	},
	appDelete: function(id) {
		return fetch({
		    url: api.appDelete + id,
		    method: 'delete'
		})
	},

	// APP极光配置管理模块
	jpushList: function(params) {
		return fetch({
		    url: api.jpushList,
		    method: 'get',
		    params: params
		})
	},
	jpushCreate: function(data) {
		return fetch({
		    url: api.jpushCreate,
		    method: 'post',
		    data: data
		})
	},
	jpushInfo: function(id) {
		return fetch({
		    url: api.jpushInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	jpushUpdate: function(data) {
		return fetch({
		    url: api.jpushUpdate,
		    method: 'put',
		    data: data
		})
	},
	jpushDelete: function(id) {
		return fetch({
		    url: api.jpushDelete + id,
		    method: 'delete'
		})
	},

	// APP的FCM配置管理模块
	fcmList: function(params) {
		return fetch({
		    url: api.fcmList,
		    method: 'get',
		    params: params
		})
	},
	fcmCreate: function(data) {
		return fetch({
		    url: api.fcmCreate,
		    method: 'post',
		    data: data
		})
	},
	fcmInfo: function(id) {
		return fetch({
		    url: api.fcmInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	fcmUpdate: function(data) {
		return fetch({
		    url: api.fcmUpdate,
		    method: 'put',
		    data: data
		})
	},
	fcmDelete: function(id) {
		return fetch({
		    url: api.fcmDelete + id,
		    method: 'delete'
		})
	},

	// APP的APNS配置管理模块
	apnsList: function(params) {
		return fetch({
		    url: api.apnsList,
		    method: 'get',
		    params: params
		})
	},
	apnsCreate: function(data) {
		return fetch({
		    url: api.apnsCreate,
		    method: 'post',
		    data: data
		})
	},
	apnsInfo: function(id) {
		return fetch({
		    url: api.apnsInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	apnsUpdate: function(data) {
		return fetch({
		    url: api.apnsUpdate,
		    method: 'put',
		    data: data
		})
	},
	apnsDelete: function(id) {
		return fetch({
		    url: api.apnsDelete + id,
		    method: 'delete'
		})
	},

	// APP个推配置管理模块
	getuiList: function(params) {
		return fetch({
		    url: api.getuiList,
		    method: 'get',
		    params: params
		})
	},
	getuiCreate: function(data) {
		return fetch({
		    url: api.getuiCreate,
		    method: 'post',
		    data: data
		})
	},
	getuiInfo: function(id) {
		return fetch({
		    url: api.getuiInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	getuiUpdate: function(data) {
		return fetch({
		    url: api.getuiUpdate,
		    method: 'put',
		    data: data
		})
	},
	getuiDelete: function(id) {
		return fetch({
		    url: api.getuiDelete + id,
		    method: 'delete'
		})
	},

	// APP极光配置管理模块
	upushList: function(params) {
		return fetch({
		    url: api.upushList,
		    method: 'get',
		    params: params
		})
	},
	upushCreate: function(data) {
		return fetch({
		    url: api.upushCreate,
		    method: 'post',
		    data: data
		})
	},
	upushInfo: function(id) {
		return fetch({
		    url: api.upushInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	upushUpdate: function(data) {
		return fetch({
		    url: api.upushUpdate,
		    method: 'put',
		    data: data
		})
	},
	upushDelete: function(id) {
		return fetch({
		    url: api.upushDelete + id,
		    method: 'delete'
		})
	},

	// 订单管理模块
	orderList: function(params) {
		return fetch({
		    url: api.orderList,
		    method: 'get',
		    params: params
		})
	},
	orderInfo: function(id) {
		return fetch({
		    url: api.orderInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	orderCount: function(params) {
		return fetch({
		    url: api.orderCount,
		    method: 'get',
		    params: params
		})
	},
	orderMap: function(params) {
		return fetch({
		    url: api.orderMap,
		    method: 'get',
		    params: params
		})
	},
	orderLoad: function(params) {
		return fetch({
		    url: api.orderLoad,
		    method: 'post',
		    params: params,
		    responseType: 'blob'
		})
	},

	// 消息管理模块
	msgList: function(params) {
		return fetch({
		    url: api.msgList,
		    method: 'get',
		    params: params
		})
	},
	msgDeviceList: function(params) {
		return fetch({
		    url: api.msgDeviceList,
		    method: 'get',
		    params: params
		})
	},
	msgDeviceFile: function(id) {
		return fetch({
		    url: api.msgDeviceFile + id,
		    method: 'get',
		    params: {}
		})
	},

	// 分享管理模块
	shareList: function(params) {
		return fetch({
		    url: api.shareList,
		    method: 'get',
		    params: params
		})
	},

	// 反馈类型管理
	feedbackTypeList: function(params) {
		return fetch({
		    url: api.feedbackTypeList,
		    method: 'get',
		    params: params
		})
	},
	feedbackTypeCreate: function(data) {
		return fetch({
		    url: api.feedbackTypeCreate,
		    method: 'post',
		    data: data
		})
	},
	feedbackTypeInfo: function(id) {
		return fetch({
		    url: api.feedbackTypeInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	feedbackTypeUpdate: function(data) {
		return fetch({
		    url: api.feedbackTypeUpdate,
		    method: 'put',
		    data: data
		})
	},
	feedbackTypeUpSort: function(data) {
		return fetch({
		    url: api.feedbackTypeUpSort,
		    method: 'put',
		    data: data
		})
	},
	feedbackTypeDelete: function(id) {
		return fetch({
		    url: api.feedbackTypeDelete + id,
		    method: 'delete'
		})
	},

	// 反馈管理
	feedbackList: function(params) {
		return fetch({
		    url: api.feedbackList,
		    method: 'get',
		    params: params
		})
	},
	feedbackInfo: function(id) {
		return fetch({
		    url: api.feedbackInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	feedbackUpStatus: function(data) {
		return fetch({
		    url: api.feedbackUpStatus,
		    method: 'put',
		    data: data
		})
	},

	logList: function(params) {
		return fetch({
		    url: api.logList,
		    method: 'get',
		    params: params
		})
	},
	logInfo: function(id) {
		return fetch({
		    url: api.logInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	logMongoList: function(params) {
		return fetch({
		    url: api.logMongoList,
		    method: 'get',
		    params: params
		})
	},

	// 统计模块
	statisticsUser: function() {
		return fetch({
		    url: api.statisticsUser,
		    method: 'get',
		    params: {}
		})
	},
	statisticsDevice: function() {
		return fetch({
		    url: api.statisticsDevice,
		    method: 'get',
		    params: {}
		})
	},
	statisticsNum: function(params) {
		return fetch({
		    url: api.statisticsNum,
		    method: 'get',
		    params: params
		})
	},
	statisticsRetain: function(params) {
		return fetch({
		    url: api.statisticsRetain,
		    method: 'get',
		    params: params
		})
	},
	statisticsDayCount: function(params) {
		return fetch({
		    url: api.statisticsDayCount,
		    method: 'get',
		    params: params
		})
	},

	// 获取统计数据列表
	appOpenList: function($params) {
		return fetch({
		    url: api.appOpenList,
		    method: 'get',
		    params: $params
		})
	},
	numStatisticsList: function($params) {
		return fetch({
		    url: api.numStatisticsList,
		    method: 'get',
		    params: $params
		})
	},

	// 获取销售数据统计数据结果
	statisticsSale: function(params) {
		return fetch({
		    url: api.statisticsSale,
		    method: 'get',
		    params: params
		})
	},

	// excel导入销售数据
	saleUploadExcel: function() {
		return api.saleUploadExcel
	},
	saleList: function(params) {
		return fetch({
		    url: api.saleList,
		    method: 'get',
		    params: params
		})
	},

	// 后台菜单管理
	menuList: function(params) {
		return fetch({
		    url: api.menuList,
		    method: 'get',
		    params: params
		})
	},
	menuCreate: function(data) {
		return fetch({
		    url: api.menuCreate,
		    method: 'post',
		    data: data
		})
	},
	menuInfo: function(id) {
		return fetch({
		    url: api.menuInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	menuUpdate: function(data) {
		return fetch({
		    url: api.menuUpdate,
		    method: 'post',
		    data: data
		})
	},
	menuUpSort: function(data) {
		return fetch({
		    url: api.menuUpSort,
		    method: 'post',
		    data: data
		})
	},
	menuDelete: function(id) {
		return fetch({
		    url: api.menuDelete + id,
		    method: 'post'
		})
	},
	menuFunc: function() {
		return fetch({
		    url: api.menuFunc,
		    method: 'get',
		    params: {}
		})
	},

	// 后台功能管理
	funcList: function(params) {
		return fetch({
		    url: api.funcList,
		    method: 'get',
		    params: params
		})
	},
	funcCreate: function(data) {
		return fetch({
		    url: api.funcCreate,
		    method: 'post',
		    data: data
		})
	},
	funcInfo: function(id) {
		return fetch({
		    url: api.funcInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	funcUpdate: function(data) {
		return fetch({
		    url: api.funcUpdate,
		    method: 'post',
		    data: data
		})
	},
	funcUpSort: function(data) {
		return fetch({
		    url: api.funcUpSort,
		    method: 'post',
		    data: data
		})
	},
	funcUpRoute: function(data) {
		return fetch({
		    url: api.funcUpRoute,
		    method: 'post',
		    data: data
		})
	},
	funcDelete: function(id) {
		return fetch({
		    url: api.funcDelete + id,
		    method: 'post'
		})
	},

	// 后台角色管理
	roleList: function(params) {
		return fetch({
		    url: api.roleList,
		    method: 'get',
		    params: params
		})
	},
	roleCreate: function(data) {
		return fetch({
		    url: api.roleCreate,
		    method: 'post',
		    data: data
		})
	},
	roleInfo: function(id) {
		return fetch({
		    url: api.roleInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	roleUpdate: function(data) {
		return fetch({
		    url: api.roleUpdate,
		    method: 'post',
		    data: data
		})
	},
	roleDelete: function(id) {
		return fetch({
		    url: api.roleDelete + id,
		    method: 'post'
		})
	},

	// 后台管理员管理
	adminerList: function(params) {
		return fetch({
		    url: api.adminerList,
		    method: 'get',
		    params: params
		})
	},
	adminerCreate: function(data) {
		return fetch({
		    url: api.adminerCreate,
		    method: 'post',
		    data: data
		})
	},
	adminerInfo: function(id) {
		return fetch({
		    url: api.adminerInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	adminerUpdate: function(data) {
		return fetch({
		    url: api.adminerUpdate,
		    method: 'post',
		    data: data
		})
	},
	adminerDelete: function(id) {
		return fetch({
		    url: api.adminerDelete + id,
		    method: 'post'
		})
	},
	adminerDisable: function(data) {
		return fetch({
		    url: api.adminerDisable,
		    method: 'post',
		    data: data
		})
	},
	adminerLifeban: function(id) {
		return fetch({
		    url: api.adminerLifeban + id,
		    method: 'post'
		})
	},
	adminerOwnerInfo: function(id) {
		return fetch({
		    url: api.adminerOwnerInfo + id,
		    method: 'get'
		})
	},
	adminerOwnerUpdate: function(data) {
		return fetch({
		    url: api.adminerOwnerUpdate,
		    method: 'post',
		    data: data
		})
	},
	adminerResetPwd: function(data) {
		return fetch({
		    url: api.adminerResetPwd,
		    method: 'post',
		    data: data
		})
	},

	// 后台登录、注销
	adminLogin: function(data) {
		return fetch({
		    url: api.adminLogin,
		    method: 'post',
		    data: data
		})
	},
	adminVerifyCode: function(params) {
		return fetch({
		    url: api.adminVerifyCode,
		    method: 'get',
		    params: params
		})
	},
	adminLogout: function(data) {
		return fetch({
		    url: api.adminLogout,
		    method: 'post',
		    data: data
		})
	},

	// 获取后台日志列表
	adminLogList: function(params) {
		return fetch({
		    url: api.adminLogList,
		    method: 'get',
		    params: params
		})
	},

	// 文件管理
	fileList: function(params) {
		return fetch({
		    url: api.fileList,
		    method: 'get',
		    params: params
		})
	},
	fileInfo: function(id) {
		return fetch({
		    url: api.fileInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	fileDelete: function(id) {
		return fetch({
		    url: api.fileDelete + id,
		    method: 'delete'
		})
	},
	fileCertCreate: function() {
		return api.fileCertCreate
	},
	fileCertUpdate: function() {
		return api.fileCertUpdate
	},

	// s3文件操作
	s3DownPreSign: function($param) {
		return fetch({
		    url: api.s3DownPreSign,
		    method: 'get',
		    params: $param
		})
	},

	// 服务器基础配置管理
	serverBaseList: function(params) {
		return fetch({
		    url: api.serverBaseList,
		    method: 'get',
		    params: params
		})
	},
	serverBaseCreate: function(data) {
		return fetch({
		    url: api.serverBaseCreate,
		    method: 'post',
		    data: data
		})
	},
	serverBaseInfo: function(id) {
		return fetch({
		    url: api.serverBaseInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	serverBaseUpdate: function(data) {
		return fetch({
		    url: api.serverBaseUpdate,
		    method: 'put',
		    data: data
		})
	},
	serverBaseDelete: function(id) {
		return fetch({
		    url: api.serverBaseDelete + id,
		    method: 'delete'
		})
	},
	serverBaseSync: function(data) {
		return fetch({
		    url: api.serverBaseSync,
		    method: 'post',
		    data: data
		})
	},

	// 服务器第三方账号配置管理
	serverAccountList: function(params) {
		return fetch({
		    url: api.serverAccountList,
		    method: 'get',
		    params: params
		})
	},
	serverAccountCreate: function(data) {
		return fetch({
		    url: api.serverAccountCreate,
		    method: 'post',
		    data: data
		})
	},
	serverAccountInfo: function(id) {
		return fetch({
		    url: api.serverAccountInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	serverAccountUpdate: function(data) {
		return fetch({
		    url: api.serverAccountUpdate,
		    method: 'put',
		    data: data
		})
	},
	serverAccountDelete: function(id) {
		return fetch({
		    url: api.serverAccountDelete + id,
		    method: 'delete'
		})
	},

	// 国家数据管理
	countryList: function(params) {
		return fetch({
		    url: api.countryList,
		    method: 'get',
		    params: params
		})
	},
	countryCreate: function(data) {
		return fetch({
		    url: api.countryCreate,
		    method: 'post',
		    data: data
		})
	},
	countryInfo: function(id) {
		return fetch({
		    url: api.countryInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	countryUpdate: function(data) {
		return fetch({
		    url: api.countryUpdate,
		    method: 'put',
		    data: data
		})
	},
	countryDelete: function(id) {
		return fetch({
		    url: api.countryDelete + id,
		    method: 'delete'
		})
	},

	// 数据同步记录管理
	dataSyncList: function(params) {
		return fetch({
		    url: api.dataSyncList,
		    method: 'get',
		    params: params
		})
	},
	dataSyncInfo: function(id) {
		return fetch({
		    url: api.dataSyncInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	dataSyncRetry: function($data) {
		return fetch({
		    url: api.dataSyncRetry,
		    method: 'post',
		    data: $data
		})
	},
	dataSyncDelete: function(id) {
		return fetch({
		    url: api.dataSyncDelete + id,
		    method: 'delete'
		})
	},

	// 同步数据类型管理
	syncTypeList: function(params) {
		return fetch({
		    url: api.syncTypeList,
		    method: 'get',
		    params: params
		})
	},
	syncTypeCreate: function(data) {
		return fetch({
		    url: api.syncTypeCreate,
		    method: 'post',
		    data: data
		})
	},
	syncTypeUpdate: function(data) {
		return fetch({
		    url: api.syncTypeUpdate,
		    method: 'put',
		    data: data
		})
	},
	syncTypeDelete: function(id) {
		return fetch({
		    url: api.syncTypeDelete + id,
		    method: 'delete'
		})
	},

	// 友情链接数据管理
	linkList: function() {
		return fetch({
		    url: api.linkList,
		    method: 'get',
		    params: {}
		})
	},
	linkCreate: function(data) {
		return fetch({
		    url: api.linkCreate,
		    method: 'post',
		    data: data
		})
	},
	linkInfo: function(params) {
		return fetch({
		    url: api.linkInfo,
		    method: 'get',
		    params: params
		})
	},
	linkDelete: function(data) {
		return fetch({
		    url: api.linkDelete,
		    method: 'delete',
		    data: data
		})
	},

	// 管理后台版本日志管理模块
	adminVersionList: function(params) {
		return fetch({
		    url: api.adminVersionList,
		    method: 'get',
		    params: params
		})
	},
	adminVersionCreate: function(data) {
		return fetch({
		    url: api.adminVersionCreate,
		    method: 'post',
		    data: data
		})
	},
	adminVersionInfo: function(id) {
		return fetch({
		    url: api.adminVersionInfo + id,
		    method: 'get',
		    params: {}
		})
	},
	adminVersionUpdate: function(data) {
		return fetch({
		    url: api.adminVersionUpdate,
		    method: 'put',
		    data: data
		})
	},
	adminVersionDelete: function(id) {
		return fetch({
		    url: api.adminVersionDelete + id,
		    method: 'delete'
		})
	},

	// 云存储操作
	cloudVideoInfo: function(params) {
		return fetch({
		    url: api.cloudVideoInfo,
		    method: 'get',
		    params: params
		})
	},
	nginxAwsSigined: function(params) {
		return fetch({
		    url: api.nginxAwsSigined,
		    method: 'get',
		    params: params
		})
	},

	// 组装GET传参url
	buildUrl: function(params) {
		var str = '?'
		for (var o in params) { str += o + '=' + params[o] + '&'}
		return  api.deviceDownloadExcel + str.slice(0, str.lastIndexOf('&'))
	},
}



// WEBPACK FOOTER //
// ./src/axios/api.js